import * as React from 'react';
import { Backdrop, Box, Button, Card,CardActions,CardContent, CardMedia, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, Stack, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function Quizzes() {
    const navigate = useNavigate();

    const {state} = useLocation()
    const [rows, setRows] = React.useState(state.data);
    const [open, setOpen] = React.useState(false);
    const [row, setRow] = React.useState(false);


    function timeStampToDate(unix_timestamp){

        const timestamp = unix_timestamp.fecha._seconds
        // Create a new JavaScript Date object based on the timestamp
        // multiplied by 1000 so that the argument is in milliseconds, not seconds
        var date = new Date(timestamp * 1000);

        // Hours part from the timestamp
        const year = date.getFullYear();

        // Minutes part from the timestamp
        const month = "0" + date.getMonth();

        // Seconds part from the timestamp
        const day = "0" + date.getDay();

        // Will display time in 10:30:23 format
        var formattedTime = day + '/' + month + '/' + year;

        return formattedTime
    }

    function onClickDoQuiz(row){
        setRow(row)
        setOpen(true)  
    }

    const handleCloseNo = () => {
        setOpen(false);
    }
    const handleCloseYes = () => {
        setOpen(false);
        
        navigate('/main/home/quizzes/quiz-questionary', {state: row});
    }


    return (
        <Box  sx={{ 
            flexGrow: 1, 
            px: 2, 
            flexGrow: 1 ,
            backgroundImage: `radial-gradient(circle at top left, rgba(60, 60, 60, 0.39) 0%, rgba(10, 10, 10, 0.86) 100%), url(https://firebasestorage.googleapis.com/v0/b/fir-820c7.appspot.com/o/media%2F1729787758406-1ir0ayqwhxf.jpg?alt=media&token=62b59009-778b-4cad-8f39-b43115b3d282) !important`,
            backgroundRepeat: `no-repeat`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: "93vh",
            width: "100%",
            }}>    
            <div sx={{ my: 1, mx: 'auto'}}>
                <Stack spacing={2} sx={{pt:8}}> 
                    {rows?.map((row) => (
                        <Card sx={{ borderRadius:2}} variant='paper'>
                            <CardContent>
                                <Typography color={"black"} gutterBottom variant='h5' sx={{fontWeight:"bolder"}}>
                                {row.nombre}
                                </Typography>
                                
                                <Stack spacing={2} sx={{pb:1}} direction={"row"}>
                                    {row.puntos > 0?
                                        <Typography color={"black"} sx={{fontSize: 18, fontWeight: "bold"}}> ¡Ganas {row.puntos} Puntos!</Typography>
                                        :
                                        <></>
                                    }
                                     {
                                    row.respondida?
                                    <Stack direction="row" spacing={2}>
                                        
                                        <Typography color={"black"} sx={{ mb: 1.5 }}>
                                            Respondida
                                        </Typography>
                                        <CheckCircleIcon style={{ color: 'green' }}/>
                                    </Stack>
                                    :  
                                    <Stack direction="row" spacing={2}>
                                       
                                        <Typography color={"black"} sx={{ mb: 1.5 }}>
                                            No respondida
                                        </Typography>
                                        <InfoIcon style={{ color: 'red' }}/>
                                    </Stack>
                                }
                                </Stack>
                               
                            </CardContent>
                            <CardActions>
                                <Button  onClick={()=>onClickDoQuiz(row)} variant='secondary'>Contestar Trivia</Button>
                            </CardActions>
                        </Card>
                    ))}
                </Stack>
                <Backdrop
                  sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                  open={open}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>
              
            </div>

            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Guna Lealtad</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                ¿Estas seguro de quieres responder esta trivia?
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={handleCloseNo}>No</Button>
                    <Button color="secondary"  onClick={handleCloseYes} autoFocus>
                        Si
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}